const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/projects",
    exact: true,
    component: "Projects",
  },
  {
    path: "/contact",
    exact: true,
    component: "Contact",
  },
];

export default routes;
